import { render } from "./AttachmentRecords.vue?vue&type=template&id=6f470c7b&ts=true"
import script from "./AttachmentRecords.vue?vue&type=script&lang=ts"
export * from "./AttachmentRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__